export default __webpack_public_path__ + "static/B0099-e1f8dcf64ad8233ea7f8db861da99830.png";